<template>
    <div>
        <b-card no-body>
            <div class="text-center mt-2">
                <h1>Supported Hosters</h1>
                <p class="mb-2">
                    On this page you can check the full list of our supported
                    filehoster services.
                </p>
            </div>
            <h4 class="text-center mt-1">* Total Daily Bandwidth: 200 GB</h4>
            <span class="text-center mb-75"
                >Last Updated: {{ last_updated }}</span
            >
            <b-table
                responsive
                :fields="fields"
                :items="items"
                class="mb-0"
                hover
            >
                <template #cell(#)><div class="stt"></div></template>
                <template #cell(host)="data">
                    <div class="host-name">
                        <router-link
                            v-if="!isLoggedIn"
                            :to="{
                                name: 'premium-link-generator',
                                params: { host: data.value.split('.')[0] },
                            }"
                            class="text-dark text-decoration-none"
                        >
                            <img
                                :src="iconHost(data.value)"
                                :alt="`${data.value} file host logo`"
                                :title="`${data.value} downloader`"
                            />{{ data.value }}
                        </router-link>

                        <span v-else>
                            <img
                                :src="iconHost(data.value)"
                                :alt="`${data.value} file host logo`"
                                :title="`${data.value} downloader`"
                            />{{ data.value }}
                        </span>

                        <span
                            v-if="hostNotice(data.value)"
                            class="host-notice"
                        >
                            <feather-icon
                                icon="InfoIcon"
                                size="14"
                                class="host-notice-icon"
                            />
                            {{ hostNotice(data.value) }}
                        </span>
                        <span
                            v-if="isUnstable(data.item.status)"
                            class="host-notice host-unstable"
                        >
                            <feather-icon
                                icon="AlertTriangleIcon"
                                size="14"
                                class="host-notice-icon"
                            />
                            Unstable
                        </span>
                    </div>
                </template>
                <template #cell(limit_bandwidth_daily)="data">
                    {{ showBwLimit(data.value) }}
                </template>
                <template #cell(limit_file_daily)="data">
                    {{ showFileLimit(data.value) }}
                </template>
                <template #cell(status)="data">
                    <b-badge pill :variant="statusVariant(data.value)">
                        {{ statusLabel(data.value) }}
                    </b-badge>
                </template>
            </b-table>
            <div
                class="status-cta d-flex flex-column flex-sm-row align-items-center justify-content-center text-center p-2 border-top"
            >
                <h4 class="status-cta-title mb-1 mb-sm-0">
                    {{ statusCta.title }}
                </h4>
                <b-button variant="primary" :to="{ name: statusCta.route }">
                    {{ statusCta.label }}
                </b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BTable, BBadge, BButton, BCard } from "bootstrap-vue";
import formatBytes from "../../mixins/format-bytes";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import moment from "moment";
export default {
    components: {
        BTable,
        BBadge,
        BButton,
        BCard,
        FeatherIcon,
    },
    mixins: [formatBytes],
    created() {
        this.$store
            .dispatch("fetchStatusHost")
            .then((res) => (this.items = res.data.data))
            .catch((err) => console.log(err));
    },
    computed: {
        showBwLimit() {
            return (size) => (size == 0 ? "Unlimited" : this.formatBytes(size));
        },
        showFileLimit() {
            return (file) => (file == 0 ? "Unlimited" : file);
        },
        hostNotice() {
            const notices = {
                "tezfiles.com": "Only Default Premium Links",
            };

            return (host) => notices[host.toLowerCase()] || "";
        },
        statusVariant() {
            const statusColor = {
                unstable: "light-success",
                working: "light-success",
                broken: "light-danger",
            };

            return (status) =>
                statusColor[String(status).toLowerCase()] ||
                "light-secondary";
        },
        statusLabel() {
            const labels = {
                unstable: "Online",
                working: "Online",
                broken: "Offline",
            };

            return (status) =>
                labels[String(status).toLowerCase()] || "Unknown";
        },
        isUnstable() {
            return (status) =>
                String(status).toLowerCase() === "unstable";
        },
        iconHost() {
            return (data) => "images/hoster/" + data + ".png";
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        statusCta() {
            if (
                this.isLoggedIn &&
                this.$store.getters.getUser.has_premium
            ) {
                return {
                    title: "Ready to download?",
                    label: "Open Downloader",
                    route: "downloader",
                };
            }

            return {
                title: "Found the host you need?",
                label: "View Pricing Plans",
                route: "plans",
            };
        },
    },
    data() {
        return {
            count: 0,
            items: [],
            fields: [
                "#",
                "host",
                "status",
                { key: "limit_bandwidth_daily", label: "Bandwidth /day *" },
                { key: "limit_file_daily", label: "Links /day" },
            ],
            last_updated: moment().utc().format("LL"),
        };
    },
    method: {},
};
</script>

<style scoped>
.status-cta-title {
    margin-right: 1rem;
}

@media (max-width: 575.98px) {
    .status-cta-title {
        margin-right: 0;
    }
}
</style>

<style>
table {
    counter-reset: section;
}
.stt:before {
    counter-increment: section;
    content: counter(section);
}
.host-name {
    display: inline-flex;
    align-items: center;
}
.host-notice {
    margin-left: 0.35rem;
    display: inline-flex;
    align-items: center;
    gap: 0.15rem;
    padding: 0.15rem 0.35rem;
    border: 1px solid rgba(255, 159, 67, 0.2);
    border-radius: 999px;
    background-color: rgba(255, 159, 67, 0.07);
    color: #c77719;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
}
.host-unstable {
    margin-left: 0.75rem;
    font-size: 0.8125rem;
}
@media (max-width: 575.98px) {
    .host-name {
        flex-direction: column;
        align-items: flex-start;
        row-gap: 0.25rem;
    }
    .host-notice {
        max-width: 100%;
        margin-left: 0;
        box-sizing: border-box;
        line-height: 1.2;
        white-space: normal;
    }
    .host-unstable {
        margin-left: 0;
    }
    .host-name > a,
    .host-name > span:not(.host-notice) {
        white-space: nowrap;
    }
}
</style>
